import {
    GETWALLETTRANSACTIONLISTBYID_SUCCESS,
    GETWALLETTRANSACTIONLISTBYID_FAILED,
    RESET_GETWALLETTRANSACTIONLISTBYID,
    LOADING_GETWALLETTRANSACTIONLISTBYID,
    NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETWALLETTRANSACTIONLISTBYID:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETWALLETTRANSACTIONLISTBYID_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETWALLETTRANSACTIONLISTBYID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETWALLETTRANSACTIONLISTBYID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETWALLETTRANSACTIONLISTBYID:
            return (state = initialState);
        default:
            return state;
    }
};
